import { Event } from './event';
import { Root } from './root';

export const Calendar = {
    Event,
    Root
};
